import { render, staticRenderFns } from "./TheBetaBanner.vue?vue&type=template&id=00700883&scoped=true"
import script from "./TheBetaBanner.vue?vue&type=script&lang=js"
export * from "./TheBetaBanner.vue?vue&type=script&lang=js"
import style0 from "./TheBetaBanner.vue?vue&type=style&index=0&id=00700883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00700883",
  null
  
)

export default component.exports